// https://app.zeplin.io/project/5caf384240aa3004f13fc00e/screen/5eb12413e353e71b01218e1a (color.seed)
import { Color } from '../Color/Color';
export var Styling = {
    gray: {
        darkest: Color.black,
        main: Color.thunder,
        dark: Color.steel,
        80: Color.steel80,
        60: Color.steel60,
        40: Color.steel40,
        20: Color.steel20,
        light: Color.gallery,
        ultralight: Color.sand,
        white: Color.white,
    },
    secondary: {
        dark: {
            default: Color.petrolBlue,
            80: Color.petrolBlue80,
            60: Color.petrolBlue60,
            40: Color.petrolBlue40,
            20: Color.petrolBlue20,
        },
        main: {
            default: Color.aquaBlue,
            80: Color.aquaBlue80,
            60: Color.aquaBlue60,
            40: Color.aquaBlue40,
            20: Color.aquaBlue20,
        },
        light: {
            default: Color.freshGreen,
            80: Color.freshGreen80,
            60: Color.freshGreen60,
            40: Color.freshGreen40,
            20: Color.freshGreen20,
        },
        fresh: {
            default: Color.grassGreen,
            80: Color.grassGreen80,
            60: Color.grassGreen60,
            40: Color.grassGreen40,
            20: Color.grassGreen20,
        },
        intense: Color.steel,
        darkcontrast: {
            text: Color.thunder,
        },
        lightcontrast: {
            text: Color.white,
        },
    },
    primary: {
        main: Color.bloodOrange,
        dark: Color.midOrange,
        light: Color.lightOrange,
        text: Color.white,
    },
    system: {
        success: {
            main: '#067417',
            light: '#edf8ee',
            text: '#067417',
        },
        error: {
            main: '#cf3516',
            light: '#fef4f4',
            text: '#cf3516',
        },
        warning: {
            main: '#f0c800',
            light: '#fbf5d5',
            text: Color.petrolBlue,
        },
        info: {
            main: '#87cdff',
            light: '#e7f5ff',
            text: Color.petrolBlue,
        },
    },
    interface: {
        background: {
            main: Color.mist,
            dark: Color.sand,
            light: Color.white,
            intense: Color.gallery,
        },
        text: {
            main: Color.thunder,
            dark: Color.petrolBlue,
            light: Color.steel60,
            contrast: Color.white,
            accent: Color.midOrange,
        },
    },
    header: {
        background: Color.white,
        text: Color.thunder,
        selector: Color.midOrange,
    },
    footer: {
        background: Color.bloodOrange,
        text: Color.white,
    },
    buttons: {
        primary: {
            filled: {
                default: "linear-gradient(90deg, " + Color.lightOrange + ", " + Color.midOrange + ")",
                hover: "linear-gradient(90deg, " + Color.lightOrange + ", " + Color.error + ")",
                active: "linear-gradient(90deg, " + Color.midOrange + ", " + Color.error + ")",
            },
            outlined: {
                outlines: Color.midOrange,
                fill: Color.white,
            },
            link: Color.midOrange,
            radius: '20px',
        },
        secondary: {
            filled: {
                default: "linear-gradient(90deg, " + Color.petrolBlue80 + ", " + Color.petrolBlue + ")",
                hover: "linear-gradient(90deg, " + Color.petrolBlue + ", #003d4d)",
            },
            outlined: {
                outlines: Color.petrolBlue,
                fill: Color.white,
            },
            link: Color.petrolBlue,
            radius: '20px',
        },
    },
    icons: {
        primary: {
            main: Color.midOrange,
            light: Color.lightOrange,
        },
        secondary: {
            dark: Color.petrolBlue,
            main: Color.aquaBlue,
            fresh: Color.grassGreen,
            light: Color.freshGreen,
        },
        light: Color.white,
    },
    forms: {
        text: {
            default: Color.thunder,
            placeholder: Color.steel60,
            disabled: Color.steel60,
        },
        background: {
            default: Color.white,
            disabled: Color.gallery,
        },
        border: {
            default: Color.steel60,
            focus: Color.steel,
            hover: Color.steel,
        },
        check: {
            focus: Color.petrolBlue,
            default: Color.petrolBlue80,
        },
    },
    tooltip: {
        background: Color.steel,
        text: Color.white,
    },
};
//# sourceMappingURL=styling.js.map